import React, { useMemo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import useSignatureEditorShim from './hooks/useSignatureEditorShim';
import { getSignatureAnchorSx } from './PrismFormEditor.pickers.styles';
import Signature from './signature/Signature';

const PrismSignatureBridge = ({ request }) => {
  const editorShim = useSignatureEditorShim(request);
  const attrs = useMemo(() => request.attributes || {}, [request.attributes]);
  const containerSx = useMemo(() => getSignatureAnchorSx(request.anchorRect), [request.anchorRect]);

  return (
    <Box sx={containerSx}>
      <Signature
        dataHellosignRequired={attrs.dataHellosignRequired}
        dataHellosignSigner={attrs.dataHellosignSigner}
        dataHellosignTag={attrs.dataHellosignTag}
        dataSigningAuthorizedSignerMode={attrs.dataSigningAuthorizedSignerMode}
        dataSigningAuthorizedSignerUserId={attrs.dataSigningAuthorizedSignerUserId}
        dataSigningDependencegroupId={attrs.dataSigningDependencegroupId}
        dataSigningDependencegroupName={attrs.dataSigningDependencegroupName}
        dataSigningDependencegroupParentId={attrs.dataSigningDependencegroupParentId}
        dataSigningDisplaySignatureLine={attrs.dataSigningDisplaySignatureLine}
        dataSigningId={attrs.dataSigningId}
        dataSigningRoleEngineConfig={attrs.dataSigningRoleEngineConfig}
        dataSigningSecurityGroupId={attrs.dataSigningSecurityGroupId}
        dataSigningUsePoaVerbiage={attrs.dataSigningUsePoaVerbiage}
        editor={editorShim}
        isNewItem={request.mode === 'insert'}
        readOnly={false}
        rootDependenceGroupId={attrs.rootDependenceGroupId}
        selectedPage={1}
      />
    </Box>
  );
};

PrismSignatureBridge.propTypes = {
  request: PropTypes.object.isRequired,
};

export default PrismSignatureBridge;
